/**
 * Galaxy section titles: fade in and rise 12px the first time they scroll into view (once per visit).
 * Titles already on screen when the page loads are left as they are. Skipped for visitors who
 * prefer reduced motion and inside the theme editor.
 */
const SELECTOR = [
  '.galaxy-collections__head',
  '.galaxy-sellers__head',
  '.galaxy-reviews__head',
  // About section heading + "01/…" label (Horizon text blocks inside the "01 About us" section)
  '[class*="__about_heading"]',
  '[class*="__about_index"]',
].join(',');

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const designMode = Boolean(window.Shopify?.designMode);

if (!reducedMotion && !designMode && 'IntersectionObserver' in window) {
  const titles = [...document.querySelectorAll(SELECTOR)];

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  for (const title of titles) {
    if (title.getBoundingClientRect().top < window.innerHeight) {
      title.classList.add('is-revealed');
    } else {
      observer.observe(title);
    }
    title.classList.add('galaxy-reveal');
  }

  document.documentElement.classList.add('galaxy-reveal-on');
}
